import request from "@/utils/request";

const prefixMap = {
    1: 'https://dev.minicreate.qq.com',
    2: 'https://dev.minipre.qq.com',
    3: 'https://dev.minipre.qq.com',
    4: 'https://eadev.dream.qq.com',
    5: 'https://dev.dream.qq.com',
}

const defaultStatus = location.href.includes('minicreate') ? 1 : 5


export const getPrefix = (envStatus) => {
    return prefixMap[envStatus || defaultStatus] || ''
}

/**
 * 11.1、获取商品列表
 * @param {Object} data - 请求参数
 * @param {number} data.status - 搜索状态，-1全部，0上架，1普通下架，2被举报下架，3审核中
 * @param {string} [data.search_content] - 搜索内容
 * @param {Object} [data.page] - 分页信息
 * @param {number} data.page.DataPerPage - 每页数量
 * @param {number} data.page.PageNow - 页数
 * @returns {Promise} 返回商品列表数据
 * @example
 * getMyModels({
 *   status: -1,
 *   search_content: "test",
 *   page: { DataPerPage: 10, PageNow: 1 }
 * })
 */
export function getMyModels(data, envStatus) {
  return request({
    url: getPrefix(envStatus) + "/api?c=developerAsset&a=myModels",
    method: "post",
    data,
  });
}

/**
 * 11.8、获取统计汇总信息
 * @returns {Promise} 返回统计数据
 * @returns {number} data.total_apply - 审核中数量
 * @returns {number} data.total_model - 总资产包数
 * @returns {number} data.total_online - 已上架数量
 * @returns {number} data.total_price - 累计收益
 * @example
 * getStatistics()
 */
export function getStatistics(envStatus) {
  return request({
    url: getPrefix(envStatus) + "/api?c=developerAsset&a=statistics",
    method: "post",
  });
}

/**
 * 11.2、获取商品销售记录
 * @param {Object} data - 请求参数
 * @param {number} data.model_id - 模组/资产ID
 * @param {Object} [data.page] - 分页信息
 * @param {number} data.page.DataPerPage - 每页数量
 * @param {number} data.page.PageNow - 页数
 * @returns {Promise} 返回销售记录列表
 * @example
 * getSales({
 *   model_id: 200000003,
 *   page: { DataPerPage: 10, PageNow: 1 }
 * })
 */
export function getSales(data,envStatus) {
  return request({
    url: getPrefix(envStatus) + "/api?c=developerAsset&a=getSales",
    method: "post",
    data,
  });
}

/**
 * 11.3、获取商品详情
 * @param {Object} data - 请求参数
 * @param {number} data.model_id - 模组/资产ID
 * @returns {Promise} 返回商品详细信息
 * @returns {string} data.name - 模组/资产名称
 * @returns {string} data.version - 版本号
 * @returns {string} data.tag - 标签
 * @returns {string} data.project_img - 封面图
 * @returns {string} data.package_url - 资产包/模组包地址
 * @returns {string} data.preview_imgs - 宣传图
 * @returns {string} data.desc - 详情说明
 * @returns {number} data.price - 售价
 * @returns {number} data.asset_type - 类型，1模组2资产
 * @example
 * getDetail({ model_id: 200000003 })
 */
export function getDetail(data,envStatus) {
  return request({
    url: getPrefix(envStatus) + "/api?c=developerAsset&a=getDetail",
    method: "post",
    data,
  });
}

/**
 * 11.4、更新商品信息
 * @param {Object} data - 请求参数
 * @param {number} data.model_id - 模组/资产ID
 * @param {string} data.name - 模组/资产名字
 * @param {string} data.editor_version - 编辑器版本号
 * @param {string} data.tag - 标签（多个用分号分隔）
 * @param {string} data.project_img - 封面图地址
 * @param {string} data.package_url - 模组/资产包地址
 * @param {string} data.preview_imgs - 宣传图地址（多个用分号分隔）
 * @param {string} data.desc - 详情说明
 * @param {number} data.price - 售价
 * @returns {Promise} 返回更新结果，data非0表示成功，0表示失败
 * @example
 * updateProduct({
 *   model_id: 200000003,
 *   name: "测试模组",
 *   editor_version: "v4.3.10",
 *   tag: "103;102",
 *   project_img: "images/asset/xxx.png",
 *   package_url: "assetmodel/xxx.zip",
 *   preview_imgs: "images/asset/xxx.png",
 *   desc: "测试说明",
 *   price: 3.9
 * })
 */
export function updateProduct(data,envStatus) {
  return request({
    url: getPrefix(envStatus) + "/api?c=developerAsset&a=update",
    method: "post",
    data,
  });
}

/**
 * 11.5、商品下线
 * @param {Object} data - 请求参数
 * @param {number} data.model_id - 模组/资产ID
 * @returns {Promise} 返回下线结果，data非0表示成功，0表示失败
 * @example
 * offlineProduct({ model_id: 200000003 })
 */
export function offlineProduct(data,envStatus) {
  return request({
    url: getPrefix(envStatus) + "/api?c=developerAsset&a=offline",
    method: "post",
    data,
  });
}

/**
 * 11.6、商品上线
 * @param {Object} data - 请求参数
 * @param {number} data.model_id - 模组/资产ID
 * @param {number} data.type - 类型，1上线，2申诉
 * @param {string} data.desc - 描述，1上线时携带的参数
 * @param {string} data.appeal_desc - 申诉理由，2申诉时携带的参数
 * @returns {Promise} 返回上线结果，data非0表示成功，0表示失败
 * @example
 * onlineProduct({ 
 *   model_id: 200000003,
 *   type: 1
 * })
 */
export function onlineProduct(data,envStatus) {
  return request({
    url: getPrefix(envStatus) + "/api?c=developerAsset&a=online",
    method: "post",
    data,
  });
}

/**
 * 11.7、删除商品
 * @param {Object} data - 请求参数
 * @param {number} data.model_id - 模组/资产ID
 * @returns {Promise} 返回删除结果，data非0表示成功，0表示失败
 * @example
 * deleteProduct({ model_id: 200000003 })
 */
export function deleteProduct(data,envStatus) {
  return request({
    url: getPrefix(envStatus) + "/api?c=developerAsset&a=delete",
    method: "post",
    data,
  });
}

/**
 * 11.10、标签列表
 * @param {Object} data - 请求参数
 * @param {number} data.model_id - 模组/资产ID
 * @returns {Promise} 返回结果，ret为1表示成功，其他表示失败
 * @example
 * getTagList()
 */
export function getTagList(envStatus) {
  return request({
    url: getPrefix(envStatus) + "/api?c=developerAsset&a=getTagList",
    method: "post",
  });
}


/**
 * 7.4、模组图片上传
 * @param {Object} data - 表单数据
 * @param {String} data.image - 图片base64String，限制2M，格式限制 jpg, png, gif, bmp, 
 * @param {String} data.name - 图片名
 * @returns {Promise} 返回图片上传结果
 * @example
 * uploadImage(data).then(res => {
 *   console.log(res.data) // 图片相对地址，如：/images/asset/20250703211713jAXd400400.png
 * })
 */
export function uploadImage(data, envStatus) {
  return request({
    url: getPrefix(envStatus) + "/api?c=developerAsset&a=uploadImage",
    method: "post",
    data,
  });
}
